document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-dv-card-swatches]').forEach(function (swatchesEl) {
    var cardWrapper = swatchesEl.closest('.card-wrapper');
    if (!cardWrapper) return;
    var mainImg = cardWrapper.querySelector('.card__media img.motion-reduce');

    swatchesEl.querySelectorAll('.dv-card-swatches__row').forEach(function (row) {
      var swatches = row.querySelectorAll('.dv-card-swatch');

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Update selected state within this row
          swatches.forEach(function (s) {
            s.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');

          // Swap card image
          var imgUrl = swatch.dataset.imgUrl;
          if (imgUrl && mainImg) {
            mainImg.srcset = '';
            mainImg.src = imgUrl;
          }
        });
      });
    });
  });
});
